
import { mapActions } from 'vuex'
import { footer } from '../customWhiteLabel'
export default {
  data() {
    return {
      dataForm: {
        telefone: '',
        endereco: {
          estado: '',
          cidade: '',
        },
      },
      loadingBtn: false,
      colorGradient: '',
      footer,
    }
  },
  head() {
    return {
      title: 'Parceiro Contador Senha Digital',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Agregue valor para seu negócio seja um indicador de Certificado Digital',
        },
      ],
    }
  },
  methods: {
    ...mapActions('slack', ['sendMessageSlack']),
    async save() {
      const formValidate = this.$refs.form.validate()
      if (!formValidate) {
        return false
      }

      this.loadingBtn = true
      try {
        const { state, ...remaining } = this.dataForm
        const resultData = {
          state: this.dataForm.state.sigla,
          ...remaining,
        }
        const query = `
                    mutation($myItemName: String!, $columns: JSON!) {
                        create_item (
                            board_id: 4264101860, 
                            item_name: $myItemName,
                            column_values: $columns
                            ){
                        id
                        }
                    }
                    `
        const variable = {
          myItemName: resultData.name,
          columns: `{"texto6" : "${resultData.email}", "texto" : "${resultData.phonerNumber}", "texto30" : "${resultData.state}", "texto09" : "${resultData.city}", "texto0" : "${resultData.understand}", "texto1" : "${resultData.observation}"}`,
        }

        await fetch('https://api.monday.com/v2', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.KEY_MONDAY,
          },
          body: JSON.stringify({
            query,
            user_id: 0,
            variables: JSON.stringify(variable),
          }),
        })
        this.$toast.success('Dados para contato enviado com sucesso!')
        this.dataForm = {}
        this.$refs.form.resetValidation()
      } catch (error) {
        console.error(error)
        this.$toast.error(error)
      } finally {
        this.loadingBtn = false
      }
    },
    contatParceiro() {
      // const linkUrl = 'https://wa.me/55' + this.footer.botaoWhatsapp
      // window.open(linkUrl, '_blank');

      const whatsappUrl = `https://wa.me/${this.footer.botaoWhatsapp}?text=${encodeURIComponent(this.footer.messageContador)}`;
      window.open(whatsappUrl, '_blanck');
    },
  },
}
